module.exports = __webpack_public_path__ + "img/HeroTypesQuiz-Q5.6ec49c4d.png";